// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer___KEAp","lds_dual_ring":"Spinner_lds_dual_ring__1p5sp","lds-dual-ring":"Spinner_lds-dual-ring__3C3BF"};